import { graphql } from "@/lib/gql/__generated__";

export const OptionStockUpdate_StockManagementPage_Mutation = graphql(`
	mutation OptionStockUpdate_StockManagementPage($input: OptionStockInput!) {
		optionStockUpdate(input: $input) {
			userErrors
			optionStock {
				id
				hotelID
				headers {
					date
					weekday
				}
				items {
					optionID
					subOptionID
					name
					isInSale
					stocks {
						date
						isAvailable
						remainNum
						soldNum
					}
				}
			}
		}
	}
`);
